import { observer } from 'mobx-react-lite'

import { DeepCloneTask } from '@/Core/Tasks/Utils/DeepCloneTask'
import { Form, FormField } from '@/Core/UI/Form'
import { FormSection } from '@/Ship/Components/Form/FormSection/FormSection'

/**
 * Поля ресурсу в картці так само, як стандартний рендер ядра без шаблону (усі, крім id).
 * Для власних шаблонів перегляду, що додають під полями свої секції.
 */
export const ResourceViewFields = observer(({ crudContext, formContext }: any) => {
    const fields = DeepCloneTask(crudContext?.resource?.fields ?? {})

    return (
        <FormSection>
            <Form formContext={formContext}>
                {Object.keys(fields).map((name) =>
                    name === 'id' ? null : <FormField key={name} name={name} {...fields[name]} />
                )}
            </Form>
        </FormSection>
    )
})
